import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import useHttp from "../hooks/useHttp";
import {useEffect} from "react";
import Error from "./Error";
import Spinner from "./Spinner";
import {classNames} from "../index";
import {activeFilterChanged, filtersFetched, filtersFetching, filtersFetchingError} from "../redux/action";
function NewsFilter() {
    const {filters,filtersLoadingStatus,activeFilter} = useSelector(state=>state.filter)
    const dispatch = useDispatch()
    const {request} = useHttp()
    useEffect(() => {
      dispatch(filtersFetching());
      request("http://localhost:3001/filters")
          .then(data=>dispatch(filtersFetched(data)))
          .catch(e=>dispatch(filtersFetchingError))
    }, []);
    if(filtersLoadingStatus==="loading"){
        return <Spinner/>
    }else if(filtersLoadingStatus==="error"){
        return <Error/>
    }
    const renderFilters=(arr)=>{
        if(arr.length===0){
            return <h5 className="text-center mt-5">Filters do not Exist! </h5>
        }
        return arr.map(({name,className,label})=>{
            const btnClasses = classNames("btn",className,{
                "active":name===activeFilter
            })
            return <button
                type='button'
                key={name}
                id={name}
                className={btnClasses}
                onClick={()=>dispatch(activeFilterChanged(name))}>
                {label}
               </button>
        })

    }
    const element = renderFilters(filters)
    return (
        <div className='card shadow-lg mt-4'>
            <div className="card-body">
                <p className="card-text">Filter by Category</p>
                <div className="btn-group">
                    {element}
                </div>
            </div>

        </div>
    );
}

export default NewsFilter;